// views/LandingPage/components/LandingPageUsagesList/filterUsages.js
import usagesList from './usagesList';
import { USAGE_TYPE_KEYS } from './usageTypes';

export const filterUsagesByTypes = (usageTypes = []) => {
  if (!usageTypes || usageTypes.length === 0) {
    return [];
  }

  return usagesList.filter(usage => {
    const usageKey = usage.usageKey;
    return usageTypes.some(type => {
      const expectedKey = USAGE_TYPE_KEYS[type];
      return expectedKey && usageKey === expectedKey;
    });
  });
};

export const parseUsageTypesFromContent = (content) => {
  // Pattern: ---usages---coworking,meetingRoom---/usages---
  const match = content.match(/\-\-\-usages\-\-\-([\s\S]*?)\-\-\-\/usages\-\-\-/);
  
  if (!match) {
    return { types: [] };
  }

  const usageContent = match[1].trim();
  // Parse: just the types (comma-separated)
  const types = usageContent.split(',').map(t => t.trim()).filter(Boolean);

  return { types };
};